import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { OrganizationUserType } from '@/bundle/_Opco/types/types';

export const getAddedUserDetailsApi = async (userId: string): Promise<ApiResponseType<OrganizationUserType>> => {
  const uri = `/opco/users/${userId}/`;

  return authApiService.GET(uri);
};
